module.exports = __webpack_public_path__ + "static/media/ic_kappaletavara_a.01deec04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/map/images/ic_kappaletavara_a.svg
// module id = 1183
// module chunks = 0